<div class="dialog-container">
  <div class="dialog-header flex_sb">
    <div class="dialog-header-title">
      {{ 'OPEN_CASH_DRAWER.DRAWER_KICK' | fallbackTranslate }}
      <div class="fs-16 fw-400 clr-333" *ngIf="billingCounterName" [innerHTML]="billingCounterInfo"></div>
    </div>
    <div class="dialog-header-cross flex-center" (click)="cancel_clicked()">
      <img [src]="images.CROSS" class="img-20" alt="close"/>
    </div>
  </div>

  <div class="dialog-form">
    <div class="sub-header">
      <p>{{ now | date: 'dd/MM/yyyy, hh:mm a' }}</p>
    </div>
    <form [formGroup]="cashCollectForm">
      <div class="form-container">
        <!-- name field -->
        <div class="form-input-container">
          <label>{{ 'OPEN_CASH_DRAWER.ENTER_STAFF_NAME' | fallbackTranslate }}</label>
          <input
            type="text"
            [placeholder]="'OPEN_CASH_DRAWER.ENTER_HERE' | fallbackTranslate"
            class="input-name-class"
            autocomplete="off"
            formControlName="staff_name"
            [ngClass]="{
              'is-invalid':
                (cashCollectForm.get('staff_name').errors &&
                  cashCollectForm.get('staff_name').touched) ||
                (cashCollectForm.get('staff_name').touched &&
                  cashCollectForm.get('staff_name').hasError('name'))
            }"
          />
          <div class="error-field">
            <div
              class="alert-text"
              *ngIf="
                cashCollectForm.get('staff_name').hasError('required') &&
                cashCollectForm.get('staff_name').touched
              "
            >
              {{ 'OPEN_CASH_DRAWER.REQUIRED' | fallbackTranslate }}
            </div>
          </div>
        </div>

        <!-- Select reason -->
        <div class="form-input-container">
          <label>{{ 'OPEN_CASH_DRAWER.SELECT_REASON' | fallbackTranslate }}</label>
          <mat-radio-group
            aria-labelledby="example-radio-group1-label"
            class="example-radio-group1"
            [(ngModel)]="selectedOption"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="radioChanged($event)"
          >
            <div class="cards__item" *ngFor="let item of reasons">
              <span
                class="example-list-section1 c-pointer"
                (click)="setRadio(item.id)"
                [ngClass]="
                  selectedOption == item.id ? 'radio-selected-div' : null
                "
              >
                <mat-radio-button
                  class="example-radio-button"
                  [value]="item.id"
                >
                  {{ item.name }}
                </mat-radio-button>
              </span>
            </div>
            <div class="cards__item">
              <span
                class="example-list-section1 c-pointer"
                (click)="setRadio('custom')"
                [ngClass]="
                  selectedOption == 'custom' ? 'radio-selected-div' : null
                "
              >
                <mat-radio-button class="example-radio-button1" value="custom">
                  <input
                    style="width: 100%"
                    [ngClass]="
                      selectedOption == 'custom'
                        ? 'custom-reason-input-active'
                        : null
                    "
                    class="custom-reason-input"
                    type="text"
                    name="reason"
                    id="reason"
                    [(ngModel)]="reason_text"
                    [ngModelOptions]="{
                      standalone: true
                    }"
                    [placeholder]="
                      'OPEN_CASH_DRAWER.ENTER_A_REASON' | fallbackTranslate
                    "
                  />
                </mat-radio-button>
              </span>
            </div>
          </mat-radio-group>
        </div>
      </div>
    </form>
    <div class="footer">
      <button
        nz-button
        nzSize="large"
        nzType="primary"
        [nzLoading]="isLoading"
        class="success-btn"
        (click)="save_clicked()"
        [disabled]="btnDisabled"
      >
        {{ 'OPEN_CASH_DRAWER.DONE' | fallbackTranslate }}
      </button>
    </div>
  </div>
</div>
